// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('WxArticleVO')
export class WxArticleVO {

  @JsonProperty('articleType', 'number')
  public articleType: number = undefined;

  @JsonProperty('articleEAN', 'number')
  public articleEAN: number = undefined;

  @JsonProperty('itemId', 'number')
  public itemId: number = undefined;

  @JsonProperty('itemNo', 'string')
  public itemNo: string = undefined;

  @JsonProperty('lengthMax', 'number')
  public lengthMax: number = undefined;

  @JsonProperty('poleCount', 'number')
  public poleCount: number = undefined;

  @JsonProperty('rgb1', 'number')
  public rgb1: number = undefined;

  @JsonProperty('texture', 'string')
  public texture: string = undefined;

  @JsonProperty('shape', 'WxArticleShapeVO')
  public shape: WxArticleShapeVO = undefined;

  @JsonProperty('connections', '[WxConnectionVO]')
  public connections: WxConnectionVO[];

  @JsonProperty('carrier', 'WxCarrierVO')
  public carrier: WxCarrierVO;
}

@JsonObject('WxArticleShapeVO')
export class WxArticleShapeVO {

  @JsonProperty('poleX', 'number')
  public poleX: number = undefined;

  @JsonProperty('poleY', 'number')
  public poleY: number = undefined;

  @JsonProperty('poleZ', 'number')
  public poleZ: number = undefined;

  @JsonProperty('shapeId', 'number')
  public shapeId: number = undefined;

  @JsonProperty('drawingElements', '[WxDrawingElementVO]')
  public drawingElements: WxDrawingElementVO[] = undefined;
}

@JsonObject('WxDrawingElementVO')
export class WxDrawingElementVO {

  @JsonProperty('drawingId', 'number')
  public drawingId: number = undefined;

  @JsonProperty('elementOrder', 'number')
  public elementOrder: number = undefined;

  @JsonProperty('coordinateX', 'number')
  public coordinateX: number = undefined;

  @JsonProperty('coordinateY', 'number')
  public coordinateY: number = undefined;

  @JsonProperty('coordinateZ', 'number')
  public coordinateZ: number = undefined;

  @JsonProperty('mirror', 'boolean')
  public mirror: boolean = undefined;

  @JsonProperty('mirrorX', 'number')
  public mirrorX: number = undefined;

  @JsonProperty('mirrorY', 'number')
  public mirrorY: number = undefined;

  @JsonProperty('mirrorZ', 'number')
  public mirrorZ: number = undefined;

  @JsonProperty('rotationX', 'number')
  public rotationX: number = undefined;

  @JsonProperty('rotationY', 'number')
  public rotationY: number = undefined;

  @JsonProperty('rotationZ', 'number')
  public rotationZ: number = undefined;

  @JsonProperty('open', 'boolean')
  public open: boolean = undefined;

  @JsonProperty('constraint', 'boolean')
  public constraint: boolean = undefined;

  @JsonProperty('drawing', 'boolean')
  public drawing: boolean = undefined;

  @JsonProperty('lineWidth', 'number')
  public lineWidth: number = undefined;

  @JsonProperty('rgb1', 'number')
  public rgb1: number = undefined;

  @JsonProperty('rgb2', 'number')
  public rgb2: number = undefined;

  @JsonProperty('rgb3', 'number')
  public rgb3: number = undefined;

  @JsonProperty('rgb4', 'number')
  public rgb4: number = undefined;

  @JsonProperty('texture', 'string')
  public texture: string = undefined;

  @JsonProperty('shapeRgb1', 'number')
  public shapeRgb1: number = undefined;

  @JsonProperty('shapeRgb2', 'number')
  public shapeRgb2: number = undefined;

  @JsonProperty('shapeRgb3', 'number')
  public shapeRgb3: number = undefined;

  @JsonProperty('shapeRgb4', 'number')
  public shapeRgb4: number = undefined;

  @JsonProperty('shapeTexture', 'string')
  public shapeTexture: string = undefined;

  @JsonProperty('lineRgb1', 'number')
  public lineRgb1: number = undefined;

  @JsonProperty('lineRgb2', 'number')
  public lineRgb2: number = undefined;

  @JsonProperty('lineRgb3', 'number')
  public lineRgb3: number = undefined;

  @JsonProperty('lineRgb4', 'number')
  public lineRgb4: number = undefined;

  @JsonProperty('line_Texture', 'string')
  public line_Texture: string = undefined;

  @JsonProperty('envelopes', '[WxEnvelopeVO]')
  public envelopes: WxEnvelopeVO[] = undefined;

  @JsonProperty('rectangles', '[WxRectangleVO]')
  public rectangles: WxRectangleVO[] = undefined;

  @JsonProperty('arcs', '[WxArcVO]')
  public arcs: WxArcVO[] = undefined;

  @JsonProperty('texts', '[WxTextVO]')
  public texts: WxTextVO[] = undefined;
}

@JsonObject('WxEnvelopeVO')
export class WxEnvelopeVO {

  @JsonProperty('closed', 'boolean')
  public closed: boolean = undefined;

  @JsonProperty('envelopeId', 'number')
  public envelopeId: number = undefined;

  @JsonProperty('points', '[WxEnvelopePointVO]')
  public points: WxEnvelopePointVO[] = undefined;
}

@JsonObject('WxEnvelopePointVO')
export class WxEnvelopePointVO {

  @JsonProperty('y', 'number')
  public y: number = undefined;

  @JsonProperty('z', 'number')
  public z: number = undefined;
}

@JsonObject('WxRectangleVO')
export class WxRectangleVO {

  @JsonProperty('length', 'number')
  public length: number = undefined;

  @JsonProperty('width', 'number')
  public width: number = undefined;
}

@JsonObject('WxArcVO')
export class WxArcVO {

  @JsonProperty('radius', 'number')
  public radius: number = undefined;

  @JsonProperty('closed', 'boolean')
  public closed: boolean = undefined;

  @JsonProperty('angle', 'number')
  public angle: number = undefined;
}

@JsonObject('WxTextVO')
export class WxTextVO {

  @JsonProperty('textId', 'number')
  public textId: number = undefined;

  @JsonProperty('length', 'number')
  public length: number = undefined;

  @JsonProperty('width', 'number')
  public width: number = undefined;

  @JsonProperty('alignmentHorizontal', 'number')
  public alignmentHorizontal: number = undefined;

  @JsonProperty('alignmentVertical', 'number')
  public alignmentVertical: number = undefined;

  @JsonProperty('fontName', 'string')
  public fontName: string = undefined;

  @JsonProperty('fontSize', 'number')
  public fontSize: number = undefined;

  @JsonProperty('fontBold', 'boolean')
  public fontBold: boolean = undefined;

  @JsonProperty('fontItalic', 'boolean')
  public fontItalic: boolean = undefined;

  @JsonProperty('fontUnderline', 'boolean')
  public fontUnderline: boolean = undefined;

  @JsonProperty('fontStrikeout', 'boolean')
  public fontStrikeout: boolean = undefined;

  @JsonProperty('linesHorizontal', 'number')
  public linesHorizontal: number = undefined;

  @JsonProperty('charsHorizontal', 'number')
  public charsHorizontal: number = undefined;

  @JsonProperty('linesVertical', 'number')
  public linesVertical: number = undefined;

  @JsonProperty('charsVertical', 'number')
  public charsVertical: number = undefined;

  @JsonProperty('description', 'string')
  public description: string = undefined;
}

@JsonObject('WxConnectionVO')
export class WxConnectionVO {

  @JsonProperty('active', 'boolean')
  public active: boolean = undefined;

  @JsonProperty('turnable', 'boolean')
  public turnable: boolean = undefined;

  @JsonProperty('drawing', 'boolean')
  public drawing: boolean = undefined;

  @JsonProperty('measure', 'boolean')
  public measure: boolean = undefined;

  @JsonProperty('connected', 'boolean')
  public connected: boolean = undefined;

  @JsonProperty('articleNo', 'string')
  public articleNo: string = undefined;

  @JsonProperty('description', 'string')
  public description: string = undefined;

  @JsonProperty('groupDescription', 'string')
  public groupDescription: string = undefined;

  @JsonProperty('connectionTypeId', 'number')
  public connectionTypeId: number = undefined;

  @JsonProperty('typeDescription', 'string')
  public typeDescription: string = undefined;

  @JsonProperty('connectionId', 'number')
  public connectionId: number = undefined;

  @JsonProperty('connectionOrder', 'number')
  public connectionOrder: number = undefined;

  @JsonProperty('direction', 'boolean')
  public direction: boolean = undefined;

  @JsonProperty('level', 'number')
  public level: number = undefined;

  @JsonProperty('corridor', 'number')
  public corridor: number = undefined;

  @JsonProperty('first', 'boolean')
  public first: boolean = undefined;

  @JsonProperty('middle', 'boolean')
  public middle: boolean = undefined;

  @JsonProperty('last', 'boolean')
  public last: boolean = undefined;

  @JsonProperty('optional', 'boolean')
  public optional: boolean = undefined;

  @JsonProperty('coordinateX', 'number')
  public coordinateX: number = undefined;

  @JsonProperty('coordinateY', 'number')
  public coordinateY: number = undefined;

  @JsonProperty('coordinateZ', 'number')
  public coordinateZ: number = undefined;

  @JsonProperty('rotationX', 'number')
  public rotationX: number = undefined;

  @JsonProperty('rotationY', 'number')
  public rotationY: number = undefined;

  @JsonProperty('rotationZ', 'number')
  public rotationZ: number = undefined;

  @JsonProperty('levelCAE', 'number')
  public levelCAE: number = undefined;

  @JsonProperty('channelCAE', 'number')
  public channelCAE: number = undefined;

  @JsonProperty('pointCAE', 'number')
  public pointCAE: number = undefined;

  @JsonProperty('speedwayInOut', 'number')
  public speedwayInOut: number = undefined;

  @JsonProperty('speedwayXOrder', 'number')
  public speedwayXOrder: number = undefined;

  @JsonProperty('alternativeConnectionOrder', 'number')
  public alternativeConnectionOrder: number = undefined;

  @JsonProperty('rgb1', 'number')
  public rgb1: number = undefined;

  @JsonProperty('rgb2', 'number')
  public rgb2: number = undefined;

  @JsonProperty('rgb3', 'number')
  public rgb3: number = undefined;

  @JsonProperty('rgb4', 'number')
  public rgb4: number = undefined;

  @JsonProperty('texture', 'string')
  public texture: string = undefined;

  @JsonProperty('drawingElements', '[WxDrawingElementVO]')
  public drawingElements: WxDrawingElementVO[] = undefined;
}

@JsonObject('WxCarrierVO')
export class WxCarrierVO {

  @JsonProperty('articleId', 'number')
  public articleId: number = undefined;

  @JsonProperty('carrierId', 'number')
  public carrierId: number = undefined;

  @JsonProperty('carrierNo', 'string')
  public carrierNo: string = undefined;

  @JsonProperty('carrierOrder', 'number')
  public carrierOrder: number = undefined;

  @JsonProperty('parentId', 'number')
  public parentId: number = undefined;

  @JsonProperty('parentType', 'number')
  public parentType: number = undefined;

  @JsonProperty('description', 'string')
  public description: string = undefined;

  @JsonProperty('remark', 'string')
  public remark: string = undefined;

  @JsonProperty('drillingTypeId', 'number')
  public drillingTypeId: number = undefined;

  @JsonProperty('drillingDimensionId', 'number')
  public drillingDimensionId: number = undefined;

  @JsonProperty('orderId', 'number')
  public orderId: number = undefined;

  @JsonProperty('autoAudit', 'boolean')
  public autoAudit: boolean = undefined;

  @JsonProperty('mountingAdapterId', 'number')
  public mountingAdapterId: number = undefined;

  @JsonProperty('type', 'number')
  public type: number = undefined;

  @JsonProperty('originalArticleId', 'number')
  public originalArticleId: number = undefined;

  @JsonProperty('languageId', 'number')
  public languageId: number = undefined;

  @JsonProperty('projectArticles', '[WxProjectArticleVO]')
  public projectArticles: WxProjectArticleVO[] = undefined;

  @JsonProperty('projectConnections', '[WxProjectConnectionVO]')
  public projectConnections: WxProjectConnectionVO[] = undefined;
}

@JsonObject('WxProjectArticleVO')
export class WxProjectArticleVO {

  @JsonProperty('projectArticleId', 'number')
  public projectArticleId: number = undefined;

  @JsonProperty('articleId', 'number')
  public articleId: number = undefined;

  @JsonProperty('poleCount', 'number')
  public poleCount: number = undefined;

  @JsonProperty('checked', 'number')
  public checked: number = undefined;

  @JsonProperty('caeGuid', 'string')
  public caeGuid: string = undefined;

  @JsonProperty('caeArticleNew', 'boolean')
  public caeArticleNew: boolean = undefined;

  @JsonProperty('caeTerminal', 'string')
  public caeTerminal: string = undefined;

  @JsonProperty('versionId', 'number')
  public versionId: number = undefined;

  @JsonProperty('projectArticleGuid', 'string')
  public projectArticleGuid: string = undefined;

  @JsonProperty('powerWireLength', 'number')
  public powerWireLength: number = undefined;

  @JsonProperty('blockId', 'number')
  public blockId: number = undefined;
}

@JsonObject('WxProjectConnectionVO')
export class WxProjectConnectionVO {

  @JsonProperty('basePin', 'WxProjectConnectionPinVO')
  public basePin: WxProjectConnectionPinVO = undefined;

  @JsonProperty('targetPin', 'WxProjectConnectionPinVO')
  public targetPin: WxProjectConnectionPinVO = undefined;
}

@JsonObject('WxProjectConnectionPinVO')
export class WxProjectConnectionPinVO {

  @JsonProperty('projectArticleId', 'number')
  public projectArticleId: number = undefined;

  @JsonProperty('pole', 'number')
  public pole: number = undefined;

  @JsonProperty('order', 'number')
  public order: number = undefined;

  @JsonProperty('connectionId', 'number')
  public connectionId: number = undefined;

  @JsonProperty('offset', 'number')
  public offset: number = undefined;

  @JsonProperty('turned', 'boolean')
  public turned: boolean = undefined;
}
